import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { EMAIL, EMAIL_HREF, HOURS, PHONE_DISPLAY, PHONE_TEL, SERVICES, TAGLINE, WHATSAPP_URL } from "@/lib/site";

const Col = ({ title, children }) => (
  <div>
    <h3 className="eyebrow text-[var(--green-bright)] mb-5">{title}</h3>
    {children}
  </div>
);

export const Footer = () => (
  <footer className="relative bg-[var(--navy-deep)] text-slate-300 grain overflow-hidden" data-testid="site-footer">
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-20 pb-10">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo light testId="footer-logo" />
          <p className="mt-6 max-w-sm leading-relaxed text-slate-300">
            Easy Handyman Services offers home improvements, garden maintenance and professional house cleaning
            for homeowners throughout Oxfordshire.
          </p>
          <p className="mt-6 font-accent text-2xl text-white">{TAGLINE}</p>
        </div>
        <div className="lg:col-span-3">
          <Col title="Services">
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services#${s.slug}`} data-testid={`footer-service-link-${s.slug}`} className="link-underline text-slate-200 hover:text-white">{s.title}</Link>
                </li>
              ))}
              <li><Link to="/gallery" data-testid="footer-gallery-link" className="link-underline text-slate-200 hover:text-white">Project gallery</Link></li>
              <li><Link to="/quote" data-testid="footer-quote-link" className="link-underline text-slate-200 hover:text-white">Request a free quote</Link></li>
            </ul>
          </Col>
        </div>
        <div className="lg:col-span-3">
          <Col title="Contact">
            <ul className="space-y-3">
              <li><a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-3 text-slate-200 hover:text-white"><Phone className="h-4 w-4 text-[var(--green-bright)]" />{PHONE_DISPLAY}</a></li>
              <li><a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 text-slate-200 hover:text-white"><MessageCircle className="h-4 w-4 text-[var(--green-bright)]" />WhatsApp us</a></li>
              <li><a href={EMAIL_HREF} data-testid="footer-email-link" className="flex items-center gap-3 text-slate-200 hover:text-white break-all"><Mail className="h-4 w-4 shrink-0 text-[var(--green-bright)]" />{EMAIL}</a></li>
              <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-[var(--green-bright)]" />Oxfordshire, UK</li>
            </ul>
          </Col>
        </div>
        <div className="lg:col-span-2">
          <Col title="Opening hours">
            <ul className="space-y-3 text-sm">
              {HOURS.map((h) => (
                <li key={h.day}><span className="block text-slate-400">{h.day}</span><span className="text-white">{h.time}</span></li>
              ))}
            </ul>
          </Col>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-sm text-slate-400">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Easy Handyman Services. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms and Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);
